
const PPMVReducer = (state, action) => {
	switch (action.type) {
		case "UPDATE": {
			return {
				surveyFormData: action.payload,
			};
		}
		case "CLEAR": {
			return {
				surveyFormData: null,
			};
		}

		default:
			return state;
	}
};

export default PPMVReducer;
